import { MdDashboard } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { BiCategory, BiPackage } from "react-icons/bi";
import { PiChalkboardTeacher } from "react-icons/pi";
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { GiTeacher } from "react-icons/gi";

export const sidebarItems = [
  {
    id: 1,
    label: "Dashboard",
    parent_id: null,
    icon: <MdDashboard size={20} />,
    module: "dashboard",
    order_index: 1,
    url: "/admin/dashboard",
  },
  {
    id: 2,
    label: "Services",
    parent_id: null,
    icon: <FaUsers size={20} />,
    module: "services",
    order_index: 2,
    url: "/admin/services",
  },
  {
    id: 3,
    label: "Customers",
    parent_id: null,
    icon: <BiCategory size={20} />,
    module: "customers",
    order_index: 3,
    url: "/admin/customers",
  },
  {
    id: 4,
    label: "Testimonial",
    parent_id: null,
    icon: <BiPackage size={20} />,
    module: "testimonial",
    order_index: 4,
    url: "/admin/testimonial",
  },

  {
    id: 5,
    label: "Users",
    parent_id: null,
    icon: <LiaChalkboardTeacherSolid size={20} />,
    module: "users",
    order_index: 5,
    url: "",
    children: [
      {
        id: 6,
        label: "User 1",
        parent_id: 5,
        icon: <PiChalkboardTeacher size={20} />,
        module: "user1",
        order_index: 6,
        url: "/admin/user1",
      },
      {
        id: 7,
        label: "user2",
        parent_id: 5,
        icon: <GiTeacher size={20} />,
        module: "user2",
        order_index: 7,
        url: "/admin/user2",
      },
    ],
  },
];
